import PageHeader from "@/components/page-header";
import { HelpCatalog } from "@/components/registrant/help/help-portal";
import { OMT_AMS_HELP_PORTAL } from "@/lib/omt-ams-help";
import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";

export const Route = createFileRoute("/omt-ams/help/")({
  component: OmtAmsHelpIndex,
});

function OmtAmsHelpIndex() {
  const [search, setSearch] = useState("");
  return (
    <div className="flex w-full flex-col">
      <PageHeader
        title="Help Center"
        subtitle="Search or browse topics for the OMT/AMS portal"
        className="mb-6"
      />
      <HelpCatalog
        search={search}
        onSearchChange={setSearch}
        catalog={OMT_AMS_HELP_PORTAL}
      />
    </div>
  );
}
